import { useContext } from 'react';
import {
    Box,
    Heading,
    Text,
} from 'theme-ui';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '~/Common';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { formatCurrency } from 'utils/helpers'
import { RegistrationDetailsContext } from '..';

const mapStateToProps = (state) => {
    return { theme: state.theme }
}

const Finished = ({ dealInEoiPhase }) => {
    const registration = useContext(RegistrationDetailsContext);
    const { eoiUser, loading, setCurrentStep } = registration;
    const { t } = useTranslation();
    useDocumentTitle(t('Registration Details'));
    const formState = eoiUser?.deal_is_ipo ? 'completeIpo' : 'complete';
    const formText = {
        complete: {
            title: 'registrationDetails.form.complete.title',
            nextSteps: dealInEoiPhase ? 'registrationDetails.form.complete.nextStepsEoi' : 'registrationDetails.form.complete.nextSteps',
            subtitle: 'registrationDetails.form.complete.subtitle',
            submit: 'registrationDetails.form.complete.submit'
        },
        completeIpo: {
            title: 'registrationDetails.form.completeIpo.title',
            nextSteps: 'registrationDetails.form.completeIpo.nextSteps',
            subtitle: 'registrationDetails.form.completeIpo.subtitle',
            submit: 'registrationDetails.form.completeIpo.submit'
        }
    }

    return (
        <Box sx={{
            display: loading ? 'none' : 'block'
        }}>

            <Box>
                    <Heading as="h1" variant="h3" sx={{ fontWeight: 500 }} mb={4}>
                        {t(formText[formState].title)}
                    </Heading>

                    {(formState === 'complete' || formState === 'completeIpo') && (
                        <>
                            <Text as="p" mb={3} sx={{
                                fontSize: 2,
                                color: 'dark'
                            }}>
                                {t(formText[formState].nextSteps)}
                            </Text>

                            {formState === 'completeIpo' && (
                                <>
                                    <Heading as="h5" variant="h5" mb={3}>Pay by Electronic Funds Transfer (EFT)</Heading>
                                    <Text as="p" mb={3} sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        {t(formText[formState].bankInstructions)}
                                    </Text>
                                    <Text as="p" sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        <Text as="span" sx={{ fontWeight: 700 }}>{t('Amount Due: ')}</Text>{formatCurrency(eoiUser.capital)}
                                    </Text>
                                    <Text as="p" sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        <Text as="span" sx={{ fontWeight: 700 }}>{t('Account Name: ')}</Text>{eoiUser.bank_account_name}
                                    </Text>
                                    <Text as="p" sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        <Text as="span" sx={{ fontWeight: 700 }}>{t('BSB: ')}</Text>{eoiUser.bank_account_bsb}
                                    </Text>
                                    <Text as="p" sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        <Text as="span" sx={{ fontWeight: 700 }}>{t('Account Number: ')}</Text>{eoiUser.bank_account_number}
                                    </Text>
                                    <Text mb={3} as="p" sx={{
                                        fontSize: 2,
                                        color: 'dark'
                                    }}>
                                        <Text as="span" sx={{ fontWeight: 700 }}>{t('Payment Reference: ')}</Text>{eoiUser.bank_reference}
                                    </Text>
                                </>

                            )}
                        </>
                    )}

                    <Text as="p" mb={3} sx={{
                        fontSize: 2,
                        color: 'dark'
                    }}>
                        {t(formText[formState].subtitle)}
                    </Text>

                    <Button variant="primary" id="registrationDetailsSubmit" sx={{ display: 'block', mt: '40px' }} onClick={() => {setCurrentStep(1)}}>{t(formText[formState].submit)}</Button>
            </Box>
        </Box>
    )
}

export default connect(mapStateToProps, null)(Finished);